module.exports = __webpack_public_path__ + "static/media/thermal-energy.ca9fd8e4.svg";